import { Route } from '@angular/router';

import { ChangePasswordComponent } from './change-password.component';

export const changePasswordRoute: Route = {
    path: 'cambiaPassword',
    component: ChangePasswordComponent,
    data: {
        pageTitle: 'pagetitles.changepassword'
    }
};
